import type { CellValue } from '../../types/excel';

/** A cell value as the text it is when Excel would read it as a formula. Office.js reads a `values` entry that
 *  starts with `=`, `+` or `-` as a formula, Excel 365 a leading `@` as implicit intersection: `+WEBSERVICE(…)`
 *  sent as a value would calculate past the formula lint, which judges the strings that start with `=` (security
 *  audit 2026-10-13, AUD-19). The server already turns such strings into text or numbers for `excel_write_cells`;
 *  this is the pane's own guard on every value it writes, labels, units and titles included. A leading space keeps
 *  the text as Excel typed it, the choice of the Audit sheet's `textCell`. A formula meant as one reaches
 *  `range.formulas` by its own path and never comes here. */
export function asText<T>(v: T): T | string {
  return typeof v === 'string' && /^[=+\-@\t\r]/.test(v) ? ` ${v}` : v;
}

export function asTextGrid(values: CellValue[][]): CellValue[][] {
  return values.map((row) => row.map((v) => asText(v)));
}
